import { ActivatedRoute } from '@angular/router';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { Component, OnInit } from '@angular/core';
import { PodVrstaDokumenta } from './podvrste-dokumenta';

@Component({
  selector: 'app-podvrste-dokumenta',
  templateUrl: './podvrste-dokumenta.component.html'
})
export class PodVrsteDokumentaComponent extends BaseModalContainer<PodVrstaDokumenta> implements OnInit {

  constructor (
    protected modalContainerService: ModalContainerService<PodVrstaDokumenta>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
){
    super(modalContainerService, activatedRoute, modalService, userService)
}

ngOnInit(){
}

}
